import ReactGA from 'react-ga'
import { ReactElement, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
import { GET_USER } from 'graphql/queries/user.query'

type PropsType = {
  isMember: boolean
  customerNumber: string
  isContributor: boolean
  children?: ReactElement
}

const DIMENSIONS = {
  USER_ID: 'dimension6',
  IS_MEMBER: 'dimension4',
  // TRACKING_VERSION: 'dimension10',
  // CLIENT_ID: 'dimension11',
  // WINDOW_ID: 'dimension12',
  // PUBLISH_DATE: 'dimension13',
  // HIT_TIME: 'dimension14',
  // HIT_TYPE: 'dimension15',
  // HIT_SOURCE: 'dimension16',
  // VISIBILITY_STATE: 'dimension17',
  // URL_QUERY_PARAMS: 'dimension9',
  // PAGE_ID: 'dimension7',
}

export const googleAnalyticsInit = () => {
  ReactGA.initialize(process.env.REACT_APP_GA_ID as string, {
    gaOptions: {
      allowLinker: true,
      cookieDomain: 'auto',
    },
  })
  //   ReactGA.ga('require', 'GTM-TQBJLSN')

  // let userJS = {}
  //
  // try {
  //   userJS = JSON.parse('${customerDataJson}')
  // } catch (e) {
  //   //anonymous user }
  // }

  // ga('create', DYNAMIC_VARIABLES.GOOGLE_ANALYTICS_ACCOUNT_ID, {
  //   allowLinker: true,
  //   cookieDomain: 'auto',
  // })

  // Google optimize

  // ga('require', 'linker') // Link sites specified in site-settings

  // if (DYNAMIC_VARIABLES && DYNAMIC_VARIABLES.AUTO_LINK_SITES) {
  //   ga('linker:autoLink', DYNAMIC_VARIABLES.AUTO_LINK_SITES)
  // }

  // Brightspot Page ID (guid)
  // if (DYNAMIC_VARIABLES && DYNAMIC_VARIABLES.PAGE_ID) {
  //   ga('set', DIMENSIONS.PAGE_ID, DYNAMIC_VARIABLES.PAGE_ID)
  // }

  // Publish Date (if existed, updated on 02/10/2021)
  // if (DYNAMIC_VARIABLES && DYNAMIC_VARIABLES.PUBLISH_DATE) {
  //   ga('set', DIMENSIONS.PUBLISH_DATE, DYNAMIC_VARIABLES.PUBLISH_DATE)
  // }

  // ga('require', 'linkid')
  // ga('require', 'ec')
  // ga('send', 'pageview')

  /*
  document.addEventListener('DOMContentLoaded', function () {
     // ON FILE LINK CLICK
    $(
      "a[href*='.pdf'],a[href*='.ashx'],a[href*='.zip'],a[href*='.docx'],a[href*='.pptx'],a[href^='http']",
    ).click(function () {
      const comp = new RegExp(location.host)
      if (comp.test($(this).attr('href'))) {
        return
      }

      const eventValue = $(this).attr('title')
        ? $(this).attr('title')
        : $(this).attr('href')

      const documentTitle = $(this).attr('title') || $(this).html() || ''
      const documentHref = $(this).attr('href') || ''
      const canonicalUrl = document.querySelector("link[rel='canonical']").href

      ga('send', 'event', 'Outbound Link', 'click', documentHref)
    })

    // ON AUDIO PLAY
    // $('audio').on('play', function () {
    //   ga('send', 'event', 'Audio', 'play', document.location.href)x
    // })
  }) */

  // Google Analytics End

  // @GTM
  // const dataLayer = []
  // if (userJS.primaryEmailAddress) {
  //   dataLayer.push({ 'Email Address Variable': userJS.primaryEmailAddress })
  // }
  //
  // dataLayer.push({
  //   Permalink: document
  //     .querySelector("link[rel='canonical']")
  //     .getAttribute('href'),
  // })
}

const GoogleAnalytics = () => {
  const location = useLocation()

  const { data } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
  })

  useEffect(() => {
    if (data) {
      const DYNAMIC_VARIABLES = {
        USER_ID: data.user?.id,
        IS_MEMBER: data.user?.membership.isMember,
        IS_CONTRIBUTOR: data.user?.isContributor,
        // GOOGLE_ANALYTICS_ACCOUNT_ID: '${googleAnalyticsAccountId}',
        // AUTO_LINK_SITES: [${autoLinkSites}],
        //   AUTO_LINK_SITES: [''],
        //  PAGE_ID: '${pageId}',
        //  DOWNLOAD_TRACK_SERVICE_URL: '${restUrl}',
        //  TRACKING_ID: '${googleAnalyticsAccountId}',
        //  PAGE_TYPE: '${pageType}',
        // PAGE_TOPICS: ${pageTopics},
        //  PRODUCT_OR_CATEGORY_CODE: '${productOrCategoryCode}',
        //  PUBLISH_DATE: '${publishDate}',
      }

      // User ID GA field and custom dimension
      if (DYNAMIC_VARIABLES && DYNAMIC_VARIABLES.USER_ID) {
        ReactGA.ga('set', 'userId', DYNAMIC_VARIABLES.USER_ID)
        ReactGA.ga('set', DIMENSIONS.USER_ID, DYNAMIC_VARIABLES.USER_ID)
      }

      // Is the customer a member
      if (DYNAMIC_VARIABLES && DYNAMIC_VARIABLES.IS_MEMBER) {
        ReactGA.ga('set', DIMENSIONS.IS_MEMBER, DYNAMIC_VARIABLES.IS_MEMBER)
      }
    }
  }, [data])

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [location])

  return <></>
}

export default GoogleAnalytics
